const slugify = (str) => str.normalize("NFC").toLowerCase().trim().replace(/[^\p{L}\p{M}\p{N}\s-]/gu, "").replace(/[\s-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 255);
const slugifyJoin = (child, parent) => {
  return [parent, child].join("__");
};
function uidUniqueSlugs(records, nameKey) {
  const names = {};
  const nameCount = {};
  records.forEach((record) => {
    const name = slugify(record[nameKey]);
    names[record.uid] = nameCount[name] ? `${name}-${nameCount[name]}` : name;
    nameCount[name] = nameCount[name] ? nameCount[name] + 1 : 1;
  });
  return names;
}
export {
  slugify,
  slugifyJoin,
  uidUniqueSlugs
};
//# sourceMappingURL=slugify.js.map
